<template>
  <div @click="grantTypeSelect(value)">
    <p v-if="!edit" @click="typeFilter">
      {{ value.grantType }}
    </p>
    <div v-if="edit" class="documents-edit">
      <label>
        <span style="color: grey">Тип стипендии:</span>
        <input v-model="value.grantType" class="edit-input">
      </label>
    </div>
    <div v-if="accessEdit" class="system-buttons">
      <v-button @click="addItemFirst(value)">+ первым</v-button>
      <v-button class="ml-2" @click="addItem(value)">+ последним</v-button>
      <v-button class="ml-2" @click="edit =!edit">Edit</v-button>
      <v-button class="ml-2" @click="deleteItem(value)">Delete</v-button>
      <v-button class="ml-2" @click="changeGrantTypePositionPrev(value)">&#8592;</v-button>
      <v-button class="ml-2" @click="changeGrantTypePositionNext(value)">&#8594;</v-button>
    </div>
  </div>
</template>

<script>
import VButton from "@/components/UI/vButton";

export default {
  name: "GrantType",
  components: {VButton},
  props: {
    value: {
      type: [Object, Array],
    },
    accessEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      edit: false
    }
  },
  methods: {
    deleteItem(item) {
      this.$emit('delete-grantType', item)
    },
    addItem(item) {
      this.$emit('add-grantType', item)
    },
    addItemFirst(item) {
      this.$emit('add-grantType-first', item)
    },
    changeGrantTypePositionPrev(item) {
      this.$emit('change-prev', item)
    },
    changeGrantTypePositionNext(item) {
      this.$emit('change-next', item)
    },
    typeFilter() {
      this.$emit('grantType-filter', this.value.grantType)
    },
    grantTypeSelect(item) {
      this.$emit('grantType-select', item)
    }
  },
}
</script>

<style lang="scss">
</style>